<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onStartTime="onStartTime"
        @onEndTime="onEndTime"
        @onChangeStatus="onChangeStatus"
      />
    </div>
    <div class="global-table-container">
      <a-button
        type="primary"
        style="margin-bottom:10px; margin-right:10px"
        @click="onCheck"
      >
        审核
      </a-button>
      <a-button
        style="margin-bottom:10px;"
        type="danger"
        @click="onDeleteAll"
      >
        删除
      </a-button>
      <span
        v-show="isShowError"
        class="errorMsg"
      >请至少选择一项</span>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="handleAnswer(record)"
          >回复列表</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除?"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import {columns} from './data/index';
import TableSearch from './components/search.vue';
export default {
  components: {TableSearch},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      id: '',
      selectedRowKeys: [],
      keyword: '',
      status: '-1',
      start_time: '',
      end_time: '',
      isShowError: false,
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/comment/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            full_name: item.full_name,
            user_realname: item.user_realname,
            content: item.content,
            status: item.status,
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
        console.log('getTableData -> this.data', this.data);

      }
    },
    // 时间搜索
    onStartTime(value){
      this.current=1;
      this.start_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
    onEndTime(value){
      this.current=1;
      this.end_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },
    // 状态搜索
    onChangeStatus(val){
      this.current=1;
      this.status=val;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },

    async onDelete(record){
      let result = await this.$http.post('/comment/del', {id: record.id});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
        this.$message.success('操作成功！');
      }
    },
    async onDeleteAll(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/comment/moreDel', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];

      }
    },
    // 审核
    async onCheck(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/comment/moreCheck', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
        this.selectedRowKeys=[];
        this.$message.success('操作成功！');
      }
    },
    // 查看回复列表
    handleAnswer(record){
      this.$router.push({path: '/answer/list', query: {id: record.id}});
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
  },
};
</script>
<style lang="scss" scoped>
.errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
    
</style>
